import { convertPriceToEther } from "../utils/web3Intraction";
// import transakSDK from "@transak/transak-sdk";
import axios from "axios";

export const BLOCKCHAIN_CURRENCY_CODE = {
  ethereum: "ETH",
  polygon: "MATIC",
  BNB: "BNB",
  AVAX: "AVAX",
};

// export const TrasnkModal = new transakSDK({
//   apiKey: "4fcd6904-706b-4aff-bd9d-77422813bbb7", // Your API Key
//   environment: "STAGING", // STAGING/PRODUCTION
//   defaultCryptoCurrency: "ETH",
//   walletAddress: "", // Your customer's wallet address
//   themeColor: "000000", // App theme color
//   fiatCurrency: "", // INR/GBP
//   email: "", // Your customer's email address
//   redirectURL: "",
//   hostURL: window.location.origin,
//   widgetHeight: "550px",
//   widgetWidth: "450px",
// });

export const BLOCKCHAIN_ENUM = [
  // { label: "Binance Smart Chain", value: "BNB" },
  //  { label: "Ethereum", value: "ethereum" },
   { label: "Ethereum", value: "GoerliETH" },
   { label: "MATIC", value: "polygon" },
];

export const getNetworkUrl = (type, settings) => {
  if (settings.blockchain.length === 0) {
    return null;
  }

  let blockchain = settings.blockchain.filter((ele) => {
    return ele.status === true && ele.type === type;
  });

  if (blockchain.length === 0) {
    return null;
  }

  blockchain = blockchain[0];

  if (blockchain.networkUrl.length === 0) {
    // CONFIGURE_SETTING_FIRST
    return null;
  }

  let blockchainNetworkUrl = blockchain.networkUrl.filter((ele) => {
    return ele.type === settings.blockchainNetworkMode;
  });

  blockchainNetworkUrl = blockchainNetworkUrl[0];

  if (!blockchainNetworkUrl.url) {
    // CONFIGURE_SETTING_FIRST
    return null;
  }

  return blockchainNetworkUrl;
};

export const getContractDetails = (type, settings) => {
  if (settings.multiSend && settings.multiSend.contractAddress.length === 0) {
    return null;
  }

  let contractAddress = settings.multiSend.contractAddress.filter((ele) => {
    return ele.type === type;
  });

  if (contractAddress.length === 0) {
    return null;
  }

  contractAddress = contractAddress[0];

  if (!contractAddress[settings.blockchainNetworkMode]) {
    // CONFIGURE_SETTING_FIRST
    return null;
  }

  return {
    abi: settings.multiSend.abi,
    contractAddress: contractAddress[settings.blockchainNetworkMode],
  };
};

export const getFeeCalucations = (item, setting) => {
  let addressArray = [];
  let priceArray = [];

  let originalPrice = item.price;
  let admin_royalties =
    Number(originalPrice) * (Number(setting.adminCommission) / 100);

  let finalPrice = 0;

  if (item.author_id._id === item.current_owner._id) {
    finalPrice = originalPrice - admin_royalties;
    addressArray.push(item.current_owner.walletAddress);
    priceArray.push(convertPriceToEther(finalPrice.toString()));
  } else {
    let royalties =
      Number(originalPrice) * (Number(item.collection_id.creatorEarning) / 100);
    finalPrice = originalPrice - (royalties + admin_royalties);

    // current owner royalities
    addressArray.push(item.current_owner.walletAddress);
    priceArray.push(
      convertPriceToEther(Number(finalPrice).toFixed(6).toString())
    );
    // priceArray.push(convertPriceToEther(finalPrice.toString()));

    // author royalities
    addressArray.push(item.collection_id.creatorAddress);
    priceArray.push(
      convertPriceToEther(Number(royalties).toFixed(6).toString())
    );
    // priceArray.push(convertPriceToEther(royalties.toString()));
  }

  //owner
  addressArray.push(setting.walletAddress.publicKey);
  priceArray.push(
    convertPriceToEther(Number(admin_royalties).toFixed(6).toString())
  );
  // priceArray.push(convertPriceToEther(admin_royalties.toString()));

  return {
    address: addressArray,
    price: priceArray,
  };
};

// export const converCryptoToDollar = async (
//   amount,
//   symbol,
//   currency = "USD"
// ) => {
//   let calculatedAmount = 0;
//   console.log("sdfasdfasdfasdf", amount, symbol, currency)
//   try {
//     if (amount && symbol) {
//       const response = await axios.get(
//         `https://min-api.cryptocompare.com/data/price?fsym=${symbol}&tsyms=${currency}`
//       );
//       calculatedAmount = response.data[currency]
//         ? response.data[currency] * amount
//         : 0;


//         console.log("thisistheresponse", response)
//       return calculatedAmount ? Number(calculatedAmount).toFixed(5) : 0;
//     } else {
//       return 0;
//     }
//   } catch (error) {
//     console.log(error, "USDErrorFound!!");
//     return 0;
//   }
// };


const COINGECKO_API_KEY =
  process.env.REACT_APP_COINGECKO_API_KEY;

const COINGECKO_API_URL =
  "https://api.coingecko.com/api/v3/simple/price";

/**
 * Maps your existing blockchain symbols and values
 * to CoinGecko coin IDs.
 */
const COINGECKO_COIN_IDS = {
  ETH: "ethereum",
  ethereum: "ethereum",
  GoerliETH: "ethereum",

  MATIC: "polygon-ecosystem-token",
  POL: "polygon-ecosystem-token",
  polygon: "polygon-ecosystem-token",

  BNB: "binancecoin",
  AVAX: "avalanche-2",
};

const getCoinGeckoConvertedPrice = async (
  amount,
  symbol,
  currency = "USD"
) => {
  try {
    if (!amount || !symbol || !currency) {
      return 0;
    }

    const normalizedSymbol = String(symbol).trim();

    const coinId =
      COINGECKO_COIN_IDS[normalizedSymbol] ||
      COINGECKO_COIN_IDS[normalizedSymbol.toUpperCase()];

    if (!coinId) {
      console.error(
        `CoinGecko coin ID is not configured for: ${symbol}`
      );

      return 0;
    }

    const targetCurrency = String(currency)
      .trim()
      .toLowerCase();

    const response = await axios.get(COINGECKO_API_URL, {
      params: {
        ids: coinId,
        vs_currencies: targetCurrency,
      },
      headers: {
        "x-cg-demo-api-key": COINGECKO_API_KEY,
      },
      timeout: 10000,
    });

    const currentPrice =
      response.data?.[coinId]?.[targetCurrency];

    if (!currentPrice) {
      console.error(
        "CoinGecko price not found:",
        response.data
      );

      return 0;
    }

    const calculatedAmount =
      Number(currentPrice) * Number(amount);

    return Number(calculatedAmount).toFixed(5);
  } catch (error) {
    console.error(
      "CoinGecko API error:",
      error.response?.status,
      error.response?.data || error.message
    );

    return 0;
  }
};

export const converCryptoToDollar = async (
  amount,
  symbol,
  currency = "USD"
) => {
  return getCoinGeckoConvertedPrice(
    amount,
    symbol,
    currency
  );
};

// export const coversion = async (
//   amount,
//   symbol,
//   currency
// ) => {
//   return getCoinGeckoConvertedPrice(
//     amount,
//     symbol,
//     currency
//   );
// };
export const coversion = async (
  amount,
  symbol,
  currency
) => {
  let calculatedAmount = 0;
  try {
    if (amount && symbol) {
      const response = await axios.get(
        `https://min-api.cryptocompare.com/data/price?fsym=${symbol}&tsyms=${currency}`
      );
      calculatedAmount = response.data[currency]
        ? response.data[currency] * amount
        : 0;
      return calculatedAmount ? Number(calculatedAmount).toFixed(5) : 0;
    } else {
      return 0;
    }
  } catch (error) {
    console.log(error, "USDErrorFound!!");
    return 0;
  }
};

export const ACTIVITY_TYPE = {
  minted: "Minted",
  transfer: "Transfer",
  admin_comission: "Admin Comission",
  bids: "Bid",
  comission: "Royality",
};

export const menus = [
  {
    id: 1,
    name: "Home",
    links: "/",
  },
  {
    id: 2,
    name: "Explore",
    links: "/explore",
  },
  {
    id: 3,
    name: "FAQ",
    links: "/faq",
  },
  {
    id: 4,
    name: "Contact",
    links: "/contact-01",
  },
  {
    id: 5,
    authToken: true,
    name: "Create",
    links: "/create-item",
  },
  {
    id: 6,
    authToken: false,
    name: "Login",
    links: "/login",
  },
];






































